import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import css from '../../../components/participation-student/topic-tables/topic-tables.scss';
import ParticipationResult from '../../../components/participation-result/participation-result';
import ParticipationImprovement from '../../../components/participation-improvement/participation-improvement';

const TOPIC_NAME = 'name';
const AVG_FIRST = 'totalFirstAttempt';
const AVG_HIGHEST = 'totalHighestAttempt';
const AVG_LATEST = 'totalLatestAttempt';
const ACTIVITY_NAME = 'name';
const NUM_ATTEMPTS = 'noOfAttempts';
const FIRST_ATTEMPT = 'firstAttemptResult';
const HIGHEST_ATTEMPT = 'highestAttemptResult';
const LATEST_ATTEMPT = 'latestAttemptResult';
const FIRST_VS_LATEST = 'firstVsLatest';
const HIGHEST_VS_LATEST = 'highestVsLatest';
const FIRST_VS_HIGHEST = 'firstVsHighest';
const SELECTION_AS_IS = 'selectionAsIs';
const IMPROVEMENT = 'Improvement';

const TOPIC_TABLE_MESSAGE = 'Message - TopicTable';

const IMPROVEMENT_OPTS = [
    {
        label: 'Label - FirstVsLatest',
        value: FIRST_VS_LATEST
    },
    {
        label: 'Label - HighestVsLatest',
        value: HIGHEST_VS_LATEST
    },
    {
        label: 'Label - FirstVsHighest',
        value: FIRST_VS_HIGHEST
    }
];

const TOPIC_TABLE_CONFIG = {
    cols: [
        {
            id: TOPIC_NAME,
            classes: css['topic-name']
        },
        {
            id: NUM_ATTEMPTS,
            name: 'Header - Attempts',
            transform: () => '',
            classes: css['num-attempts']
        },
        {
            // this is set properly in the improvement specific configs below
            id: IMPROVEMENT,
            name: IMPROVEMENT,
            transform: () => '',
            classes: css.improvement
        },
        generateAverageResultCol(AVG_FIRST, 'Header - First'),
        generateAverageResultCol(AVG_HIGHEST, 'Header - Highest'),
        generateAverageResultCol(AVG_LATEST, 'Header - Latest')
    ],
    nestedData: {
        id: 'activityParticipations',
        collapse: { enable: true },
        emptyDataMessage: 'Empty - NoActivities',
        messageTopicTable: 'Message - TopicTable',
        cols: [
            {
                id: ACTIVITY_NAME,
                classes: css['activity-name'],
                truncate: true
            },
            { id: NUM_ATTEMPTS, classes: css['num-attempts'] },
            { name: IMPROVEMENT, classes: css.improvement }, // this is set properly in the improvement specific configs below
            generateResultCol(FIRST_ATTEMPT),
            generateResultCol(HIGHEST_ATTEMPT),
            generateResultCol(LATEST_ATTEMPT)
        ]
    }
};

const FIRST_VS_LATEST_TABLE_CONFIG = generateImprovementConfig(FIRST_VS_LATEST);
const HIGHEST_VS_LATEST_TABLE_CONFIG = generateImprovementConfig(
    HIGHEST_VS_LATEST
);
const FIRST_VS_HIGEST_TABLE_CONFIG = generateImprovementConfig(
    FIRST_VS_HIGHEST
);

/**
 * Generates the improvement-type specific config from the base topic table config, adding the correct col and
 * nested data col into the config for improvement type (first vs latest, latest vs highest, first vs highest)
 */
function generateImprovementConfig(improvementType) {
    const improvementConfig = cloneDeep(TOPIC_TABLE_CONFIG);
    const topicImprovementCol = improvementConfig.cols.find(
        (col) => col.name === IMPROVEMENT
    );
    const activityImprovementCol = improvementConfig.nestedData.cols.find(
        (col) => col.name === IMPROVEMENT
    );

    topicImprovementCol.name = improvementType;
    activityImprovementCol.id = improvementType;
    activityImprovementCol.transform = (row) => (
        <ParticipationImprovement improvement={row[improvementType]} />
    );

    return improvementConfig;
}

/**
 * Generates col config for a topic average result col
 */
function generateAverageResultCol(id, name) {
    return {
        id,
        name,
        classes: css['result-attempt'],
        transform: (row) => <ParticipationResult result={row[id]} isAverage />
    };
}

/**
 * Generates col config for an activity result col
 */
function generateResultCol(id) {
    return {
        id,
        classes: css['result-attempt'],
        transform: (row) => <ParticipationResult result={row[id]} />
    };
}

export {
    FIRST_VS_LATEST_TABLE_CONFIG,
    HIGHEST_VS_LATEST_TABLE_CONFIG,
    FIRST_VS_HIGEST_TABLE_CONFIG,
    TOPIC_TABLE_MESSAGE,
    IMPROVEMENT_OPTS,
    IMPROVEMENT,
    FIRST_VS_LATEST,
    FIRST_VS_HIGHEST,
    HIGHEST_VS_LATEST,
    SELECTION_AS_IS
};



// WEBPACK FOOTER //
// ./containers/participation/student/student-constants.js